var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconRuler = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        type: 'svg',
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M3.75 8.25V16.5C3.75 16.914 3.414 17.25 3 17.25C2.586 17.25 2.25 16.914 2.25 16.5V7.5C2.25 7.086 2.586 6.75 3 6.75H21C21.414 6.75 21.75 7.086 21.75 7.5V16.5C21.75 16.914 21.414 17.25 21 17.25C20.586 17.25 20.25 16.914 20.25 16.5V8.25H18.75V12C18.75 12.414 18.414 12.75 18 12.75C17.586 12.75 17.25 12.414 17.25 12V8.25H15.75V12C15.75 12.414 15.414 12.75 15 12.75C14.586 12.75 14.25 12.414 14.25 12V8.25H12.75V16.5C12.75 16.914 12.414 17.25 12 17.25C11.586 17.25 11.25 16.914 11.25 16.5V8.25H9.75V12C9.75 12.414 9.414 12.75 9 12.75C8.586 12.75 8.25 12.414 8.25 12V8.25H6.75V12C6.75 12.414 6.414 12.75 6 12.75C5.586 12.75 5.25 12.414 5.25 12V8.25H3.75Z", fill: "black" }))),
        alt: 'Icon Ruler',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconRuler;
//# sourceMappingURL=index.js.map